enum EventStatus {
  Available = 'Available',
  NotAvailable = 'NotAvailable',
  Full = 'Full',
  Waitlist = 'Waitlist',
  Selected = 'Selected',
}
export default EventStatus;
